import React from 'react';
import { ThumbnailImage, ThumbnailImageProps } from './ThumbnailImage';
import { styles } from './StackedThumbnailImage.css';

export type StackedThumbnailImageProps = {
  thumbnails: Array<ThumbnailImageProps>;
  isStacked?: boolean;
};

export const StackedThumbnailImage = ({ thumbnails, isStacked = false }: StackedThumbnailImageProps) => {
  return (
    <div className={styles.stackedThumbnailImage({ isStacked })}>
      {thumbnails.map((thumbnailProps, i) => (
        <ThumbnailImage key={i} {...thumbnailProps} />
      ))}
    </div>
  );
};
